import { fork, call, put, all, takeEvery } from "redux-saga/effects";
import asyncInterface from "../../../../asyncInterface";
import * as actionTypes from "./actionTypes";

function submitNeedAssistance(fetchPayload) {
  const fetchData = asyncInterface.init();
  return fetchData.needAssistance.submitData(fetchPayload);
}

function* postNeedAssistanceWorker(fetchPayload) {
  try {
    const response = yield call(submitNeedAssistance, fetchPayload.payload);
    yield put({
      type: actionTypes.fetchDataSuccessType,
      payload: fetchPayload.payload.data
    });
  } catch (error) {
    yield put({
      type: actionTypes.fetchDataFailureType,
      error
    });
  }
}
function* postNeedAssistanceWatcher() {
  yield takeEvery(
    actionTypes.submitNeedAssistanceDataType,
    postNeedAssistanceWorker
  );
}

function* needAssistanceDrawerWorker() {
  yield put({ type: actionTypes.showNaDrawerType });
}

function* needAssistanceDrawerWatcher() {
  yield takeEvery(
    actionTypes.showAssistanceComponentType,
    needAssistanceDrawerWorker
  );
}

function* needAssistanceSubmissionDoneWorker() {
  yield put({ type: actionTypes.submissionDoneType });
}

function* needAssistanceSubmissionDoneWatcher() {
  yield takeEvery(
    actionTypes.showAssistanceDoneType,
    needAssistanceSubmissionDoneWorker
  );
}

export default function* commonSagaWatcher() {
  yield all([
    fork(needAssistanceSubmissionDoneWatcher),
    fork(needAssistanceDrawerWatcher),
    fork(postNeedAssistanceWatcher)
  ]);
}
